import React, { useEffect } from 'react';
import Body from './components/body';
import axios from 'axios';
import { useState } from 'react';
import './App.css';
function App() {
  let [digimons,setDigimons] = useState([]);
  useEffect(()=>{
    axios.get('https://digimon-api.vercel.app/api/digimon').then((response)=>
  {
    setDigimons(response.data);
    console.log(digimons);
  })
  },[]);

  return (
    <div>
    <Body digimons = {digimons}/>
    </div>
  )
}

export default App;
